module.exports = __webpack_public_path__ + "static/img/avatar.c58e4651.png";